<template>
  <compose
    view="sms"
    :title="$t('composeMessage.title')"
    size="size1000"
  >
    <white-block-content-loader class="mt-4" />
  </compose>
</template>

<script setup lang="ts">
import Compose from '@/components/domain/compose/Compose.vue'
import WhiteBlockContentLoader from '@/components/shared/templates/WhiteBlockContentLoader.vue'
</script>
